<template>
  <RadioCardListItem
    :label="label"
    :help="help"
    :image="image"
    :isSelected="isSelected"
    :rightLabel="rightLabel"
    :rightHelp="rightHelp"
    :hideCheckbox="hideCheckbox"
    :isMega="true"
    :isComparison="true"
    :isSticky="isSticky"
  >
    <template #bottom>
      <div class="pl-5 pr-8 pb-4 text-left mt-[-0.875rem]">
        <div class="flex-col justify-end items-start inline-flex">
          <div class="self-stretch justify-start items-baseline inline-flex flex-col md:flex-row md:gap-1">
            <div v-if="discountedAmount !== undefined" class="text-base-bold text-racq-error-red text-xl2">
              {{ toCurrency(discountedAmount)}}
              <span
                v-if="amountSymbol"
                :class="{ 'ml-1': marginLeftForAmountSymbol }"
              >
                <sup> {{ amountSymbol }}</sup>
              </span>
            </div>
            
            <div v-else class="text-base-bold text-racq-dark-grey text-xl2">
              {{ formattedAmount }}
              <span v-if="amountSymbol" :class="{ 'ml-1': marginLeftForAmountSymbol }">
                <sup>{{ amountSymbol }}</sup>
              </span>
            </div>

            <div class="text-xs text-racq-dark-grey">
              {{ frequencyLabel }}
            </div>
          </div>
          <div v-if="discountedAmount !== undefined" class="text-xs text-racq-dark-grey">   
            Was
            <span class="line-through">
              {{ toCurrency(amount) }}
            </span>
          </div>
        </div>
        <div v-if="tagText" class="mt-1 flex">
          <Tag :tagType="TagTypes.discount" :tagText="tagText" />
        </div>
      </div>
    </template>
  </RadioCardListItem>
</template>

<script setup lang="ts">
import { ImageField } from '@sitecore-jss/sitecore-jss-vue/types/components/Image';
import RadioCardListItem from './RadioCardListItem.vue';
import { toCurrency } from '@/utils/convert';
import Tag from '@/components/Tag/Tag.vue';
import { TagTypes } from '@/enums/tag-enums';
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    label: string;
    help?: string;
    image?: ImageField;
    isSelected: boolean;
    rightLabel?: string;
    rightHelp?: string;
    hideCheckbox?: boolean;
    amount: number;
    discountedAmount?: number;
    tagText?: string;
    amountSymbol?: string;
    isSticky?: boolean;
    prorataSymbol?: string;
    frequencyLabel?: string;
    marginLeftForAmountSymbol?: boolean;
    removeSpaceAfterProRataSymbol?: boolean;
  }>(),
  {
    frequencyLabel: 'Per year',
  }
);

const formattedAmount = computed(() => {
  if (props.prorataSymbol) {
    const space = props.removeSpaceAfterProRataSymbol ? '' : ' ';
    return `${props.prorataSymbol}${space}${toCurrency(props.amount)}`;
  }
  return toCurrency(props.amount);
});
</script>